angular.module('picmonicng').directive('browseView', [
  '$rootScope',
  '$compile',
  '$templateRequest',
  '$controller',
  'BrowseService',
  function ($rootScope, $compile, $templateRequest, $controller, BrowseService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var childScope = null;
        var loadTemplate = function (data) {
          if (data.route.view == attrs.browseView) {
            $templateRequest(data.route.template).then(function (template) {
              //If there is an old view, destroy the scope so it doesnt persist after the html is gone
              if (childScope) {
                childScope.$destroy();
              }

              //Compile new template
              template = angular.element(template);
              element.html(template);
              childScope = scope.$new();
              $compile(template)(childScope);

              // Bind controller to the browse container
              if (data.route.controller) {
                // Alert the scope that the element is contained within browse
                scope.inBrowse = true;
                var controller = $controller(data.route.controller, {
                  $scope: childScope,
                  $browseStateParams: data.params || {},
                });
                element.data('$ngControllerController', controller);
              }
            });
          }
        };

        $rootScope.$on('browseStateChange', function (event, data) {
          loadTemplate(data);
        });

        if (BrowseService.secondaryVisible) {
          loadTemplate({
            state: BrowseService.secondaryState,
            route: BrowseService.getRoute(BrowseService.secondaryState),
            params: BrowseService.secondaryParams,
          });
        } else {
          loadTemplate({
            state: BrowseService.state,
            route: BrowseService.getRoute(BrowseService.state),
            params: BrowseService.params,
          });
        }
      },
      controller: function () {
        this.browsing = true;
      }, // DO NOT DELETE
    };
  },
]);
